import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "../components/AuthShell";
import { useContent } from "../lib/content";
import CheckEmail from "../components/CheckEmail";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function Ingresar() {
  const { t } = useContent();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [unverified, setUnverified] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      signIn(data);
      toast.success(`Bienvenida/o, ${data.user.name} ✦`);
      navigate("/mi-panel");
    } catch (err) {
      if (err?.response?.status === 403) setUnverified(true);
      else toast.error(errMsg(err, "No se pudo entrar"));
    } finally { setLoading(false); }
  };

  if (unverified) return <CheckEmail email={form.email} />;

  return (
    <AuthShell testid="ingresar-page" overline="Mi cuenta" title={t("plat_login_title")}>
      <form onSubmit={submit} data-testid="login-form" className="space-y-5">
        <div><label className="field-label">Correo</label>
          <input data-testid="login-email" type="email" required className="input-field" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
        <div><label className="field-label">Contraseña</label>
          <input data-testid="login-password" type="password" required className="input-field" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
        <button data-testid="login-submit" type="submit" disabled={loading} className="btn-lilac w-full justify-center">
          {loading ? "Entrando…" : "Entrar"}
        </button>
      </form>
      <div className="flex flex-wrap justify-between gap-3 text-sm text-zinc-500 mt-6">
        <Link to="/recuperar" data-testid="login-to-forgot" className="hover:text-[#C9A25E]">¿Olvidaste tu contraseña?</Link>
        <Link to="/registro" data-testid="login-to-register" className="text-[#C9A25E] hover:underline">Crear cuenta</Link>
      </div>
    </AuthShell>
  );
}
